module.exports = __webpack_public_path__ + "static/media/zhengshu2.4e85a61e.png";